import styled from "styled-components";
import { Link } from "react-router-dom";
import { Small } from "orcs-design-system";
import themeGet from "@styled-system/theme-get";

export const GrandchildContainer = styled.div`
  background: ${themeGet("colors.greyLightest")};
  border-radius: ${themeGet("radii.2")};
  border: 1px solid transparent;
  transition: all 0.2s ease-in-out;
  margin: 0 ${themeGet("space.r")};

  &:hover,
  &:focus-within {
    border: 1px solid ${themeGet("colors.grey")};
  }
`;

export const GrandchildLink = styled(Link)`
  text-decoration: none;
  display: block;
  padding: ${themeGet("space.s")};
  color: ${themeGet("colors.greyDarkest")};
  transition: color 0.2s ease-in-out;

  &:hover,
  &:focus {
    color: ${themeGet("colors.primary")};
    text-decoration: none;
  }
`;

export const GrandchildName = styled(Small)`
  font-weight: normal;
  font-size: ${themeGet("fontSizes.1")};
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  word-break: break-word;
  line-height: 1.3;
`;
